import Link from 'next/link';
import { useProduct } from '../ProductCard';
import { IProduct } from '@monofront/types';
import { Highlight as ISHighlight } from 'react-instantsearch';
import { Hit } from 'instantsearch.js';

export interface IProductTitleProps {
  handleClick?: (event: React.SyntheticEvent) => void;
  href?: string;
  target?: string;
}

const titleTCWClasses =
  '!tw-mb-0 tw-grid-area-[title] tw-lf-body-regular-sm tw-line-clamp-3 tw-min-h-6 tw-overflow-hidden tw-overflow-ellipsis desktop:tw-line-clamp-2';

export const ProductTitle = ({
  handleClick,
  href,
  target,
}: IProductTitleProps) => {
  const product = useProduct();
  const link = href ?? `/products/${product?.handle ?? ''}`;

  if (!product) {
    return (
      <div
        data-testid="product-title"
        className="tw-m-2 !tw-mb-0 tw-h-6 tw-w-10/12 tw-animate-pulse tw-rounded-md tw-bg-black-200 tw-grid-area-[title]"
      ></div>
    );
  }

  return handleClick || link !== '' ? (
    <Link
      data-testid="product-title"
      className={`after:tw-absolute after:tw-left-0 after:tw-top-0 after:tw-block after:tw-h-full after:tw-w-full after:tw-content-[''] ${titleTCWClasses}`}
      href={link}
      onClick={handleClick}
      target={target}
    >
      {product.title}
    </Link>
  ) : (
    <p data-testid="product-title" className={titleTCWClasses}>
      {product.title}
    </p>
  );
};

const Highlight: React.FC<IProductTitleProps> = ({ handleClick, href }) => {
  const product = useProduct();
  const link = href ?? `/products/${product?.handle ?? ''}`;

  if (!product) {
    return null;
  }

  return (
    <span
      className={`${
        '' /* Fixes the css
      injected in the product card's h2 */
      } tw-lf-body-regular-sm tw-line-clamp-1 tw-line-clamp-3 tw-flex
    tw-min-h-6
    tw-overflow-hidden
    tw-overflow-ellipsis !tw-border-0 !tw-pb-0 tw-grid-area-[title]
    desktop:tw-line-clamp-2`}
    >
      <Link
        className="after:tw-absolute after:tw-left-0 after:tw-top-0 after:tw-block after:tw-h-full after:tw-w-full after:tw-content-['']"
        href={link}
        onClick={handleClick}
      >
        <ISHighlight
          highlightedTagName={'span'}
          classNames={{
            nonHighlighted: 'tw-lf-body-bold-sm',
          }}
          hit={product as Hit<IProduct>}
          attribute="title"
        ></ISHighlight>
      </Link>
    </span>
  );
};

export const HorizontalSearchProductTitle = Highlight;

export const HorizontalProductTitle = ({
  handleClick,
  href,
}: IProductTitleProps) => {
  const product = useProduct();
  const link = href ?? `/products/${product?.handle ?? ''}`;

  if (!product) {
    return (
      <div
        data-testid="product-title"
        className="tw-m-2 tw-h-6 tw-w-10/12 tw-animate-pulse tw-rounded-md tw-bg-black-200 tw-grid-area-[title]"
      ></div>
    );
  }

  return (
    <h2
      data-testid="product-title"
      className={`
              !tw-border-0 !tw-pb-0 tw-grid-area-[title] ${
                '' /* Fixes the css injected in the product card's h2 */
              }
              tw-lf-body-regular-sm
              tw-line-clamp-3 tw-min-h-6 tw-overflow-hidden tw-overflow-ellipsis
              desktop:tw-line-clamp-2
            `}
    >
      {handleClick || link !== '' ? (
        <Link
          className="after:tw-absolute after:tw-left-0 after:tw-top-0 after:tw-block after:tw-h-full after:tw-w-full after:tw-content-['']"
          href={link}
          onClick={handleClick}
        >
          {product.title}
        </Link>
      ) : (
        <>{product.title}</>
      )}
    </h2>
  );
};
